import {baseURL} from '@/httpService/API';
import {hMacAjax} from 'grt-tool-lib-front';

interface genUrlResult {
    success: boolean;
    data: string | undefined | null;
}

let service = baseURL + '/apaas-system-service';
export let URL = {
    taskList: `${service}/sync/task/list`,
    obsSignUrl: 'https://apaas.grtcloud.net/api/obs/signed/url'
};

//通过组织名称组织树列表
export async function handleDownloadTaskList() {
    return hMacAjax.get(URL.taskList);
}

export const getDownloadSignUrl = async (bucket: string, key: string): Promise<genUrlResult> => {
    try {
        const result: Response = await fetch(URL.obsSignUrl, {
            method: 'POST',
            body: JSON.stringify({
                bucketName: bucket,
                objectKey: key,
                method: 'GET'
            })
        });
        return result.json().then((res) => {
            const {success, data} = res;
            if (!success) return {success: false, data: null};
            let {result: SignedResult} = data,
                {SignedUrl: url} = SignedResult;
            return {success: true, data: url};
        });
    } catch (error) {
        return {success: false, data: JSON.stringify(error)};
    }
};
